export const HOME_PAGE_USER_RESTRICTION_SEEN = "HOME_PAGE_USER_RESTRICTION_SEEN";

export const DS_HELPLINE_NUMBER = "9240263601";

export const DEFAULT_PER_PAGE_SIZE_OPTIONS = [50, 100, 150];
